<template>  
  <div class="search-dest">
    <h1 class="md-title md-title--light text-align-left pt-4 pb-4">Prenota ora la <br />tua prossima meta!</h1>          
      <vue-google-autocomplete
        id="map"
        classname="form-control"
        placeholder="Dove vuoi andare?"
        types="(cities)"
        v-on:placechanged="getAddressData" >
      </vue-google-autocomplete>
      <md-datepicker v-model="form.when">
        <label>Quando?</label>
      </md-datepicker>
      <nna-button color="light" class="pt-4" @click.native="onSearch">CERCA</nna-button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import moment from 'moment'
export default {
  name: 'SearchDestination',
  components: {
    VueGoogleAutocomplete
  },
  data() {
    return {
      form: {
        when: '',
        where: ''
      }    
    }
  },
  computed: {
    ...mapGetters({
      shops: 'shops/shops',
      reservationDateForServer: 'global/reservationDateForServer'
    }),
    shopsInfo() {
      return this.shops && this.shops.shopsInfo ? this.shops.shopsInfo : ''
    }
  },
  methods: {
    ...mapActions({
      getShops: 'shops/getShops'
    }),
    moment: function () {
      return moment();
    },
    getAddressData: function (addressData, placeResultData, id) {
        this.form.where = {
          lat: addressData.latitude,
          lng: addressData.longitude,
        }
    },
    onSearch() {
      if(this.form.when) {
        this.$store.commit("global/SET_RESERVATION_DATE", this.form.when)
        this.$router.push({ name: 'shops', query: { date: this.reservationDateForServer, lat: this.form.where.lat, lng: this.form.where.lng }})
      } else {
        this.$toasted.show('Inserire la data di prenotazione', { type: 'info' })    
      }      
    },
    
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.search-dest {
  .md-title {
    line-height: 32px;;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/common/components/searchDestination/SearchDestination.vue